import { Link } from 'react-router-dom';

const footerGalleryImages = [
  {
    src: 'https://static.readdy.ai/image/3b8ad55d4ff58d61aa412f5935e39846/1d3b9ccf43e603226e103140e0cc6884.jpeg',
    title: 'Chrome Ore Drilling Operations',
  },
  {
    src: 'https://static.readdy.ai/image/3b8ad55d4ff58d61aa412f5935e39846/f99639ebc7bfcad8022a6b3e88df7cea.jpeg',
    title: 'Chrome Processing Plant',
  },
  {
    src: 'https://static.readdy.ai/image/3b8ad55d4ff58d61aa412f5935e39846/82f2c7cdb30250df162db38a009014d8.jpeg',
    title: 'Spiral Concentrator Plant',
  },
  {
    src: 'https://static.readdy.ai/image/3b8ad55d4ff58d61aa412f5935e39846/29f821809ccae55c0add2340fb43077a.jpeg',
    title: 'TMI Logistics Fleet',
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#7D1E1E] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Tlotlo Mfolwe Incorporated</h3>
            <p className="text-gray-200 text-sm">
              TMI aims to be the sought-after chrome supplier guaranteeing strong relationships with its raw material suppliers and its clients and all stakeholders in its operating environment in order to deliver client centric solutions and create value so that it is sustained in the long term.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-gray-200 hover:text-white transition-colors text-sm">Home</a>
              </li>
              <li>
                <a href="/about" className="text-gray-200 hover:text-white transition-colors text-sm">About Us</a>
              </li>
              <li>
                <a href="/mining" className="text-gray-200 hover:text-white transition-colors text-sm">TMI Mining</a>
              </li>
              <li>
                <a href="/logistics" className="text-gray-200 hover:text-white transition-colors text-sm">TMI Logistics</a>
              </li>
              <li>
                <a href="/product-market" className="text-gray-200 hover:text-white transition-colors text-sm">Product Market</a>
              </li>
              <li>
                <a href="/gallery" className="text-gray-200 hover:text-white transition-colors text-sm">Gallery</a>
              </li>
              <li>
                <a href="/contact" className="text-gray-200 hover:text-white transition-colors text-sm">Contact</a>
              </li>
            </ul>
          </div>

          {/* Photo Gallery */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Photo Gallery</h4>
            <div className="grid grid-cols-2 gap-2">
              {footerGalleryImages.map((img) => (
                <a
                  key={img.title}
                  href="/gallery"
                  className="group relative block w-full h-20 rounded-lg overflow-hidden cursor-pointer"
                >
                  <img
                    src={img.src}
                    alt={img.title}
                    className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/30 group-hover:bg-black/10 transition-colors duration-300 rounded-lg"></div>
                </a>
              ))}
            </div>
            <a
              href="/gallery"
              className="inline-block mt-3 text-xs text-gray-300 hover:text-white transition-colors underline underline-offset-2 cursor-pointer"
            >
              View full gallery →
            </a>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-2 text-sm">
              <li className="text-gray-200">
                Tuscan Gardens Office Park, Noordwyk, Midrand
              </li>
              <li className="text-gray-200">010 634 2114</li>
              <li className="text-gray-200">info@tlominc.co.za</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-center text-sm text-gray-200">
          <p>© 2026 Tlotlo Mfolwe Incorporated. All rights reserved. | Powered by <a href="https://www.uniqova.co.za" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Uniqova</a></p>
        </div>
      </div>
    </footer>
  );
}
